import React from 'react';
import { ButtonProps, DropdownButton, Icon } from '@odin-labs/components';
import { ScheduleStatus } from 'apollo/generated/client-operations';
import { CircleHalfStrokeIcon, CircleCheckIcon } from 'components/icons';
import { ensureNonEmptyItems } from 'utils';
import { useJobsiteSchedules } from './jobsiteSchedulesProvider';

const scheduleStatusLabels: Record<ScheduleStatus, string> = {
  [ScheduleStatus.NotStarted]: 'Not started',
  [ScheduleStatus.InProgress]: 'In progress',
  [ScheduleStatus.Completed]: 'Completed',
};

const scheduleStatusIcon: Record<ScheduleStatus, undefined | Icon> = {
  [ScheduleStatus.NotStarted]: undefined,
  [ScheduleStatus.InProgress]: CircleHalfStrokeIcon,
  [ScheduleStatus.Completed]: CircleCheckIcon,
};

export function JobsiteScheduleStatusButton(): React.ReactElement {
  const { completeSchedule, editSchedule, selectedSchedule } =
    useJobsiteSchedules();
  const { status: scheduleStatus } = selectedSchedule || {};

  // TODO: Re-enable this when the reset schedule feature is ready
  // const {
  //   value: isResetModalOpen,
  //   setTrue: openResetModal,
  //   setFalse: closeResetModal,
  // } = useBoolean();

  const theme: ButtonProps['theme'] = React.useMemo(() => {
    switch (scheduleStatus) {
      case ScheduleStatus.Completed:
        return 'safe';
      case ScheduleStatus.InProgress:
        return 'warning';
      case ScheduleStatus.NotStarted:
      default:
        return 'white';
    }
  }, [scheduleStatus]);

  return (
    <>
      <DropdownButton
        disabled={
          !selectedSchedule || scheduleStatus === ScheduleStatus.NotStarted
        }
        icon={scheduleStatusIcon[scheduleStatus]}
        menuItems={ensureNonEmptyItems([
          scheduleStatus === ScheduleStatus.Completed && {
            text: 'Edit schedule',
            onClick: editSchedule,
          },
          scheduleStatus === ScheduleStatus.InProgress && {
            text: 'Complete schedule',
            onClick: completeSchedule,
          },
          // TODO: Re-enable this when the reset schedule feature is ready
          // {
          //   text: 'Reset Schedule',
          //   onClick: openResetModal,
          // },
        ])}
        size="sm"
        theme={theme}
      >
        {scheduleStatusLabels[scheduleStatus] ?? 'Not started'}
      </DropdownButton>
      {/* TODO: Re-enable this when the reset schedule feature is ready
      <ResetScheduleModal
        isOpen={isResetModalOpen}
        closeModal={closeResetModal}
        selectedSchedule={selectedSchedule}
      /> */}
    </>
  );
}
